const GenericErrorMessage = ({ message }: { message: string }) => {
  return <div style={{ color: 'red', marginTop: '10px' }}>{message}</div>;
};

export default GenericErrorMessage;
